import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import HeadSub from '../../../components/comm/HeadSub';
import ConfirmBox from '../../../components/box/ConfirmBox';
import AlertBox from '../../../components/box/AlertBox';
import ToastPopup from '../../../components/comm/ToastPopup';
import style from './ChangePassword.module.css';

import { getIsDpAuthCheckPwd, setDpAuthChangePassword } from '../../../assets/js/comm';
import axiosApi from '../../../api/daonAxios';

const ChangePassword = () => {

    const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

    const navigate = useNavigate();

    const [step, setStep] = useState(1);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const [pwView, setPwView] = useState(false);
    const [rePwView, setRePwView] = useState(false);

    const [currentPassword, setCurrentPassword] = useState('');
    const [currentPwError, setCurrentPwError] = useState(false);

    const [password, setPassword] = useState('');
    const [rePassword, setRePassword] = useState('');
    const [showRePassword, setShowRePassword] = useState(false);

    const handlePwView = () => setPwView(!pwView);
    const handleRePwView = () => setRePwView(!rePwView);

    const [isChange, setIsChange] = useState(null);

    // ConfirmBox 상태
    const [alertCallback, setAlertCallback] = useState(null);

    const [isAlertOpen, setIsAlertOpen] = useState(false);

    const [alertText, setAlertText ] = useState("");

    const handleOnAlertClose = () => {
        setIsAlertOpen(false);
    };

    const [pwRules, setPwRules] = useState({ length: false, number: false, letter: false, special: false });

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
        setPwRules({
            length: value.length >= 9,
            number: /\d/.test(value),
            letter: /[a-zA-Z]/.test(value),
            special: /[!@#$%^&*(),.?":{}|<>]/.test(value),
        });
    };

    const isPasswordValid = Object.values(pwRules).every(Boolean);
    const isRePasswordValid = password && password === rePassword;

    useEffect(() => {
        setShowRePassword(Object.values(pwRules).every(Boolean));
    }, [pwRules]);

    const handleNext = () => {
        passwordVerify();
    };

    const handleSubmit = () => {
        changeDpPassword();
    };

    const handleConfirmClose = (gbn) => {
        setIsAlertOpen(false);
        if (gbn && alertCallback) alertCallback();
    };

    /////////////////

    const handleCurrentPasswordChange = (e) => {
        setCurrentPassword(e.target.value);
        setCurrentPwError(false); // 에러 초기화
    };

    const passwordVerify = useCallback(() => {
        getIsDpAuthCheckPwd( loginUser.usrUid, currentPassword)
        .then( (res) => {
            //console.log( "  ====> handleOnConfirm getIsDpAuthCheckPwd res : ", res );
            if(res) {
                setStep(2);
            } else {
                setAlertText('비밀번호가 일치하지 않습니다.\n다시 확인해주세요.');
                setAlertCallback(null);
                setIsAlertOpen(true);
                return;
            }
        })
        .catch( (err) => {
            console.log( " ====> handleOnConfirm getIsDpAuthCheckPwd error : ", err );
            setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
            setToast(true);
        })

    },[loginUser, currentPassword])

    const handleRePasswordChange = (e) => {
        setRePassword(e.target.value);
    };

    const changeDpPassword = useCallback(() => {

        const usrInfo = {
            usrId : loginUser.usrId,
            usrPswd : currentPassword,
            newPswd : password
        }

        setDpAuthChangePassword( usrInfo, setIsChange)

    },[loginUser, currentPassword, password, rePassword])

    useEffect(() => {
        if(isChange != null) {
            if(isChange?.status === 200) {
                saveChangePassword();
            } else {
                setToastMessage(isChange?.response?.data?.message || '문제가 발생하였습니다. 관리자에 문의해주세요.');
                setToast(true);
            }
        }
    },[isChange]);

    const saveChangePassword = useCallback(() => {
        const url = "/setting/password/change";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = { headers: { Authorization: `Bearer ${jToken}` } };

        axiosApi.put(url, {usrPswd : password}, reqOptions)
        .then((res) => {
            if(res.status === 200) {
                setAlertText('비밀번호 변경이 완료되었습니다.');
                setAlertCallback(() => () => navigate(-1));
                setIsAlertOpen(true);
            } else {
                setToastMessage('문제가 발생하였습니다. 관리자에 문의해주세요.');
                setToast(true);
            }
        })
        .catch(err => {
            console.error("현재 비밀번호 변경 중 오류 : ", err);
        })
    },[password])

    return (
        <>
            <HeadSub title="비밀번호 변경" />
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-padding="30">
                    <div className={style['content-box']}>
                        <strong className={style['title']}>
                            {step === 1 ? '현재 비밀번호를 입력해주세요.' : '새 비밀번호를 설정해주세요.'}
                        </strong>

                        {step === 1 && (
                            <div className={style['input-wrap']}>
                                <span className={style['input-tit']}>현재 비밀번호</span>
                                <div className={style['input-box']}>
                                    <div className={style['pw-box']}>
                                        <input
                                            type={pwView ? 'text' : 'password'}
                                            placeholder="비밀번호를 입력해주세요"
                                            value={currentPassword}
                                            onChange={handleCurrentPasswordChange}
                                        />
                                        <span className={style['line']} />
                                    </div>
                                    <button className={style['pw-view-btn']} data-view={pwView ? 'on' : 'off'}
                                        onClick={() => setPwView(!pwView)}>
                                        <span className="blind">패스워드 on/off</span>
                                    </button>
                                </div>
                                {/* {currentPwError && (
                                    <div className={style['input-bottom-box']}>
                                        <span className={style['error']}>비밀번호가 일치하지 않습니다</span>
                                    </div>
                                )} */}
                            </div>
                        )}

                        {step === 2 && (
                            <>
                                {showRePassword && (
                                    <div className={style['input-wrap']}>
                                        <div className="animation-2">
                                            <span className={style['input-tit']}>새 비밀번호 확인</span>
                                            <div className={style['input-box']}>
                                                <div className={style['pw-box']}>
                                                    <input
                                                        type={rePwView ? 'text' : 'password'}
                                                        placeholder="새 비밀번호를 다시 입력해주세요"
                                                        value={rePassword}
                                                        onChange={handleRePasswordChange}
                                                    />
                                                    <span className={style['line']} />
                                                </div>
                                                <button
                                                    className={style['pw-view-btn']}
                                                    data-view={rePwView ? 'on' : 'off'}
                                                    onClick={handleRePwView}
                                                >
                                                    <span className="blind">패스워드 on/off</span>
                                                </button>
                                            </div>
                                            <div className={style['input-bottom-box']}>
                                                {rePassword && (
                                                    <span className={isRePasswordValid ? style['on'] : style['error']}>
                                                        {isRePasswordValid ? '비밀번호가 일치합니다' : '비밀번호가 일치하지 않습니다'}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className={style['input-wrap']}>
                                    <span className={style['input-tit']}>새 비밀번호</span>
                                    <div className={style['input-box']}>
                                        <div className={style['pw-box']}>
                                            <input type={pwView ? 'text' : 'password'} placeholder="새 비밀번호를 입력해주세요"
                                                value={password} onChange={handlePasswordChange} />
                                            <span className={style['line']} />
                                        </div>
                                        <button className={style['pw-view-btn']} data-view={pwView ? 'on' : 'off'}
                                            onClick={() => setPwView(!pwView)}>
                                            <span className="blind">패스워드 on/off</span>
                                        </button>
                                    </div>
                                    <div className={style['input-bottom-box']}>
                                        <span className={pwRules.length ? style['on'] : ''}>9자리 이상</span>
                                        <span className={pwRules.letter ? style['on'] : ''}>영문</span>
                                        <span className={pwRules.number ? style['on'] : ''}>숫자</span>
                                        <span className={pwRules.special ? style['on'] : ''}>특수문자</span>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className="btn-layout" data-btn-num="1">
                                {step === 1 ? (
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg"
                                        onClick={handleNext} disabled={!currentPassword}>
                                        <span>다음</span>
                                    </button>
                                ) : (
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg"
                                        onClick={handleSubmit} disabled={!isPasswordValid || !isRePasswordValid}>
                                        <span>확인</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AlertBox
                isOpen={isAlertOpen}
                onClose={handleOnAlertClose}
                onCloseCallback={handleConfirmClose}
                message={alertText}
                btnTxt='확인'
            />
{/*
            <ConfirmBox
                isOpen={confirmOpen}
                setIsOpen={setConfirmOpen}
                onCloseCallback={handleConfirmClose}
                message={confirmMsg}
                leftBtnTxt="취소"
                rightBtnTxt="확인"
            /> */}

            {toast && <ToastPopup setToast={setToast} message={toastMessage} position="center" opacity="90" />}
        </>
    );
};

export default ChangePassword;
